(function () {
  'use strict';

  function initSwiper(el) {
    var cols = parseInt(el.dataset.itemToShow, 10) || 4;
    var showArrows = el.dataset.itemArrows !== 'false';
    var container = el.closest('.mtrx-recs-outer') || el.parentElement;

    return new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 12,
      navigation: showArrows ? {
        nextEl: container.querySelector('.mtrx-slider-next'),
        prevEl: container.querySelector('.mtrx-slider-prev'),
      } : false,
      breakpoints: {
        576: { slidesPerView: 2.2, spaceBetween: 16 },
        1025: { slidesPerView: cols - 0.4, spaceBetween: 20 },
      },
    });
  }

  // product-recommendations: AJAX-loaded — watch [data-recommendations-block] for innerHTML swap
  function watchRecs() {
    var block = document.querySelector('[data-recommendations-block]');
    if (!block) return;

    var obs = new MutationObserver(function () {
      var el = block.querySelector('.mtrx-recs-swiper');
      if (el && !el.classList.contains('swiper-initialized')) {
        initSwiper(el);
        obs.disconnect();
      }
    });
    obs.observe(block, { childList: true });
  }

  // product-recently-viewed: fires mtrx:rv-ready when cookie-based AJAX loading finishes
  document.addEventListener('mtrx:rv-ready', function (e) {
    var el = e.target;
    if (el && !el.classList.contains('swiper-initialized')) {
      initSwiper(el);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRecs);
  } else {
    watchRecs();
  }
})();
